import gql from "graphql-tag";

export const QUERY_SEARCH_PLACES = gql`
  query searchPlaces($input: String!, $language: String) {
    searchPlaces(input: $input, language: $language) {
      placeId
      description
      mainText
      secondaryText
    }
  }
`;

export const QUERY_ALL_POPULAR_DESTINATIONS = gql`
  query allPopularDestinations {
    allPopularDestinations {
      id
      names
      googlePlaceId
      cityId
      islandId
      photoUrl
      sortOrder
      active
    }
  }
`;

export const QUERY_RESOLVE_DESTINATION_CITY = gql`
  query resolveDestinationCity($placeId: String!) {
    resolveDestinationCity(placeId: $placeId) {
      cityId
      islandId
      label
    }
  }
`;

export const MUTATION_CREATE_DESTINATION = gql`
  mutation createPopularDestination(
    $names: JSON!
    $googlePlaceId: String
    $cityId: Int
    $islandId: Int
  ) {
    createPopularDestination(
      names: $names
      googlePlaceId: $googlePlaceId
      cityId: $cityId
      islandId: $islandId
    ) {
      id
      names
      googlePlaceId
      cityId
      islandId
      photoUrl
      sortOrder
      active
    }
  }
`;

export const MUTATION_UPDATE_DESTINATION = gql`
  mutation updatePopularDestination(
    $id: Int!
    $names: JSON
    $googlePlaceId: String
    $cityId: Int
    $islandId: Int
    $active: Boolean
    $sortOrder: Int
  ) {
    updatePopularDestination(
      id: $id
      names: $names
      googlePlaceId: $googlePlaceId
      cityId: $cityId
      islandId: $islandId
      active: $active
      sortOrder: $sortOrder
    ) {
      id
      names
      googlePlaceId
      cityId
      islandId
      photoUrl
      sortOrder
      active
    }
  }
`;

export const MUTATION_DELETE_DESTINATION = gql`
  mutation deletePopularDestination($id: Int!) {
    deletePopularDestination(id: $id)
  }
`;

export const MUTATION_UPLOAD_PHOTO = gql`
  mutation uploadDestinationPhoto($id: Int!, $file: Upload!) {
    uploadDestinationPhoto(id: $id, file: $file) {
      id
      photoUrl
    }
  }
`;
